import React from 'react';
import Home7 from "../../components/home-7";

const Boursorama = () => {
    return (
            <>
                <Home7 />
            </>
    );
};

export default Boursorama;
